import { apiUrl } from "../enviroments/enviroments.dev";
import { CreateSupplierReceiptPayload, ISupplierReceipt } from "../models/SupplierReceipts";
import { Api } from "./Api";

const target = "/supplier-receipts";

export class SupplierReceiptsService {

    public static create(payload: CreateSupplierReceiptPayload): Promise<any> {
        return Api.post(apiUrl(`${target}/create`), payload);
    }

    public static getByOrganization(orgId: number): Promise<Array<ISupplierReceipt>> {
        return Api.get(apiUrl(`${target}/organization/${orgId}`));
    }

    public static findOne(id: string): Promise<ISupplierReceipt> {
        return Api.get(apiUrl(`${target}/${id}`));
    }
}
